//菜单
export const menuList = [
  {
    path: "/index",
    content: "首页"
  },
  {
    path: "/work",
    content: "工作要闻"
  },
  {
    path: "/media",
    content: "媒体发声"
  },
  {
    path: "/active",
    content: "活动专区"
  },
  {
    path: "/video",
    content: "视频专区"
  },
  {
    path: "/dlamor",
    content: "金融先进专区"
  },
  {path: "/download",
    content: "资料下载"
  },
  {
    path: "https://jrghlaomo.kjcxchina.com",
    content: "网上申报"
  },
  {
    path: "https://jrgjpy.kjcxchina.com/#/login",
    content: "工匠培育"
  },
  {
    path: "https://jrljjs.kjcxchina.com/#/index",
    content: "绿色金融竞赛"
  }
];
//首页VR展厅
export const vrList= [
  {
    link: 'https://jrghvr.kjcxchina.com',
    img: require('@/assets/vr/0.jpg')
  },
  {
    link: 'https://720yun.com/t/59vkb7fw51q?scene_id=92792515',
    img: require('@/assets/vr/9.jpg')
  },
  {
    link: 'https://720yun.com/t/c4vkbwrhd7m?scene_id=92110868',
    img: require('@/assets/vr/10.jpg')
  },
  {
    link: 'https://720yun.com/t/c3vkzmqm7fm?scene_id=83507746',
    img: require('@/assets/vr/5.jpg')
  },
  {
    link: 'https://720yun.com/t/9cvkbefyOfe',
    img: require('@/assets/vr/6.jpg')
  },
];
//先进专区
export const dlamorData = [
  {
    id: "0",
    mian: "五一劳动奖状单位",
    box: [
      {
        image: require('@/assets/dlamor/01.png'),
        text: "中国人民银行-拉萨中心支行"
      },
      {
        image: require('@/assets/dlamor/02.png'),
        text: "中国进出口银行-甘肃省分行"
      },
      {
        image: require('@/assets/dlamor/03.png'),
        text: "中国工商银行-河北雄安分行"
      },
      {
        image: require('@/assets/dlamor/04.png'),
        text: "中国银行-浙江长三角一体化示范区支行"
      },
      {
        image: require('@/assets/dlamor/05.png'),
        text: "招商银行-北京首体支行"
      },
      {
        image:  require('@/assets/dlamor/ind__dw01.jpg'),
        text: "中国工商银行广东中山分行"
      },
      {
        image: require('@/assets/dlamor/ind__dw02.jpg'),
        text: "中国农业银行宁波慈溪分行"
      },
      {
        image: require('@/assets/dlamor/ind__dw03.png'),
        text: "中信建投证券金融部"
      },
      {
        image: require('@/assets/dlamor/ind__dw04.jpg'),
        text: "太平人寿昆山支公司"
      }
    ]
  },
  {
    id: "1",
    mian: "五一劳动奖章获得者",
    box: [
      {
        image: require('@/assets/dlamor/18.jpg'),
        text: "许展旋"
      },
      {
        image: require('@/assets/dlamor/17.jpg'),
        text: "王志杰"
      },
      {
        image: require('@/assets/dlamor/16.jpg'),
        text: "王保国"
      },
      {
        image: require('@/assets/dlamor/15.jpg'),
        text: "刘博"
      },
      {
        image: require('@/assets/dlamor/14.jpg'),
        text: "陈利娟"
      },
      {
        image: require('@/assets/dlamor/13.jpg'),
        text: "马立项"
      },
      {
        image: require('@/assets/dlamor/06.jpg'),
        text: "孙彦杰"
      },
      {
        image: require('@/assets/dlamor/07.jpg'),
        text: "刘平"
      },
      {
        image: require('@/assets/dlamor/08.jpg'),
        text: "卢飞"
      },
      {
        image: require('@/assets/dlamor/ind-peo01.jpg'),
        text: "段柳平"
      },
      {
        image: require('@/assets/dlamor/ind-peo02.jpg'),
        text: "李宜忠"
      },
      {
        image: require('@/assets/dlamor/ind-peo03.jpg'),
        text: "徐琳喆"
      },
      {
        image: require('@/assets/dlamor/ind-peo04.jpg'),
        text: "杨浩"
      },
      {
        image: require('@/assets/dlamor/ind-peo05.jpg'),
        text: "原红波"
      },
      {
        image: require('@/assets/dlamor/ind-peo06.jpg'),
        text: "刘永欣"
      },
      {
        image: require('@/assets/dlamor/ind-peo07.jpg'),
        text: "李二国"
      },
      {
        image: require('@/assets/dlamor/ind-peo08.jpg'),
        text: "陈红"
      },
      {
        image: require('@/assets/dlamor/ind-peo09.jpg'),
        text: "王磊"
      }
    ]
  },
  {
    id: "2",
    mian: "工人先锋号集体",
    box: [
      {
        image: require('@/assets/dlamor/09.png'),
        text: "国家开发银行-西藏分行驻阿里地区札达县底雅乡什布奇村驻村工作队"
      },
      {
        image: require('@/assets/dlamor/10.png'),
        text: "中国工商银行-甘肃东风场区分行营业室"
      },
      {
        image: require('@/assets/dlamor/11.png'),
        text: "中国农业银行-广州流花支行营业部"
      },
      {
        image: require('@/assets/dlamor/12.png'),
        text: "中国银河证券股份有限公司-广州东风中路证券营业部"
      },
      {
        image: require('@/assets/dlamor/ind-jt01.jpg'),
        text: "国家开发银行浙江分行评审处"
      },
      {
        image: require('@/assets/dlamor/ind-jt02.jpg'),
        text: "农业发展银行黑龙江建三江支行"
      },
      {
        image: require('@/assets/dlamor/ind-jt03.jpg'),
        text: "中国银行苏州分行营业部"
      },
      {
        image: require('@/assets/dlamor/ind-jt04.jpg'),
        text: "中国建设银行深圳市分行小企业业务部(普惠金融事业部)"
      },
      {
        image: require('@/assets/dlamor/ind-jt05.jpg'),
        text: "交通银行浙江省分行杭州众安支行"
      },
      {
        image: require('@/assets/dlamor/ind-jt06.jpg'),
        text: "中信集团中信兴业集团中信港口投资有限公司投资发展部"
      },
      {
        image: require('@/assets/dlamor/ind-jt07.jpg'),
        text: "中国光大银行北京分行营业部"
      },
      {
        image: require('@/assets/dlamor/ind-jt08.jpg'),
        text: "招商银行北京西二旗支行"
      },
      {
        image: require('@/assets/dlamor/ind-jt09.jpg'),
        text: "中国长城资产管理股份有限公司浙江省分公司资产经营部"
      },
      {
        image: require('@/assets/dlamor/ind-jt010.jpg'),
        text: "中国东方资产管理股份有限公司北京市分公司资产经营二部"
      },
      {
        image: require('@/assets/dlamor/ind-jt011.jpg'),
        text: "中国信达资产管理股份有限公司金融机构业务部"
      },
      {
        image: require('@/assets/dlamor/ind-jt012.jpg'),
        text: "中国银河证券股份有限公司绍兴证券营业部"
      },
      {
        image: require('@/assets/dlamor/ind-jt013.jpg'),
        text: "中国民族证券有限责任公司质量控制部"
      },
      {
        image: require('@/assets/dlamor/ind-jt014.jpg'),
        text: "阳光财产保险股份有限公司许昌中心支公司"
      },
      {
        image: require('@/assets/dlamor/ind-jt015.jpg'),
        text: "太平人寿保险有限公司上海分公司电商销售业务部"
      }
    ]
  }
];
//金融工匠在线学习平台
export const jinRong= [
  {
    link: 'https://jjjs.kskstudy.com',
    pic: require('@/assets/jin-rong/1.jpg')
  },
  {
    link: 'https://jjjs.kskstudy.com',
    pic: require('@/assets/jin-rong/2.jpg')
  },
  {
    link: 'https://jjjs.kskstudy.com',
    pic: require('@/assets/jin-rong/3.jpeg')
  },
  {
    link: 'https://jjjs.kskstudy.com',
    pic: require('@/assets/jin-rong/4.jpeg')
  }
];